const generateFieldKey = (...keys) => keys.filter(Boolean).join('_').toLowerCase();

export default generateFieldKey;
